var DealEventPipe, VariationsWidget, _scrollToBuyButton;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Collections == null) {
  VariationsWidget.Collections = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Collections.Option = require('./models/option-collection');

VariationsWidget.Views.OptionCollection = require('./views/option-collection');

VariationsWidget.Views.Error = require('./views/error');

VariationsWidget.Controller = require('./variations-widget-controller');

DealEventPipe = require('../../deal/frontend/event_pipe');

_scrollToBuyButton = function() {
  var top;
  if ($('#purchase-cluster .buy.fixed').length || $('.header-row-sticked').length || $('.header-row-sticky').length) {
    top = $('.main').position().top - 100;
    return $('body,html').animate({
      scrollTop: top
    }, 500);
  }
};

VariationsWidget.init = function(arg, done) {
  var offer, stickyHeader, variations;
  variations = arg.variations, offer = arg.offer, stickyHeader = arg.stickyHeader;
  if (variations == null) {
    return done();
  }
  this.options = variations.options, this.traits = variations.traits, this.mappings = variations.mappings, this.uuid = variations.uuid, this.dealOptionUuid = variations.dealOptionUuid, this.preSelectTraits = variations.preSelectTraits, this.printSoldOut = variations.printSoldOut, this.printOptionPrice = variations.printOptionPrice, this.clearTraitsOnCarouselSelection = variations.clearTraitsOnCarouselSelection, this.hideUnrelatedOption = variations.hideUnrelatedOption;
  this.collections = VariationsWidget.Collections.Option.create(this.traits);
  this.offerCollections = offer;
  BuyButton.eventBus.board('buy_button_clicked', (function(_this) {
    return function() {
      if (BuyButton.view.variationsSelected) {
        return;
      }
      _this.controller.showErrorMessages();
      if (stickyHeader) {
        _scrollToBuyButton();
      }
      BuyButton.view.enableBuyButton();
      return {
        stopTheBus: true
      };
    };
  })(this));
  return $((function(_this) {
    return function() {
      var ref;
      _this.views = VariationsWidget.Views.OptionCollection.create(_this.collections);
      _this.error = new VariationsWidget.Views.Error({
        el: '#variation-error'
      });
      _this.controller = new VariationsWidget.Controller();
      if ((ref = _this.options) != null ? ref[0].hideOriginalPriceAndDiscount : void 0) {
        $('.deal-discount').hide();
        $('.price-and-value .discount-value').html("");
      }
      $(document.body).on("carouselUpdate", function(e, data) {
        if (payload.firedByTraitSelection) {
          return payload.firedByTraitSelection = false;
        }
        if (data.image !== _this.controller.lastImage) {
          return _this.controller.findMatchingTraits(data.image);
        }
      });
      return done();
    };
  })(this));
};

module.exports = VariationsWidget;

//# sourceMappingURL=data:application/json;base64,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
